module.exports = __webpack_public_path__ + "static/media/mun-min.f2d710f6.png";